import { defineMessages } from "react-intl";

export const SHOPIFY_MESSAGES = defineMessages({
  shopifyConnectStepOneTitle: {
    id: "funding-application: shopify connect step one title",
    defaultMessage: "Click ‘Connect store’ below",
  },
  shopifyConnectStepOneDescription: {
    id: "funding-application: shopify connect step one description",
    defaultMessage: "You’ll be taken to the Shopify App Store.",
  },
  shopifyConnectStepTwoTitle: {
    id: "funding-application: shopify connect step two title",
    defaultMessage: "Install the Wayflyer app on Shopify",
  },
  shopifyConnectStepTwoDescription: {
    id: "funding-application: shopify connect step two description",
    defaultMessage:
      "When you see the Wayflyer app, install it by clicking the button on the screen. You will be prompted to login to Shopify if you haven’t done so already.",
  },
  shopifyConnectStepThreeTitle: {
    id: "funding-application: shopify connect step three title",
    defaultMessage: "Connect your store",
  },
  shopifyConnectStepThreeDescription: {
    id: "funding-application: shopify connect step three description",
    defaultMessage:
      "Once you have installed the Wayflyer app on your Shopify store, you’ll be redirected back to us to view your connection.",
  },
  shopifyDataUsage: {
    id: "funding-application: shopify data usage",
    defaultMessage:
      "We use your Shopify data to determine how much funding we can offer. This data provides key insights into your business performance and how your business is likely to grow. To enable access, please install the Wayflyer app on your Shopify account.",
  },
  shopifyConnectSubHeading: {
    id: "funding-application: shopify connect sub heading",
    defaultMessage: "Connecting a single Shopify store",
  },
  shopifyConnectStoreLabel: {
    id: "funding-application: connect store label",
    defaultMessage: "Connect store",
  },
});
